/* RP BEAUTY - Bot�n 'Comprar ahora' (rppay-buynow). L�gica CENTRALIZADA (carga site-wide desde theme.liquid).
   Usa event delegation ? aplica a CUALQUIER .rppay-buynow actual o futuro, en cualquier plantilla/bloque.
   Arregla: (1) bot�n pegado en 'Procesando...' al volver por bfcache; (2) producto forzado al carrito si el cliente retrocede.
   NO duplicar inline en plantillas. Editar SOLO aqu�. */
(function(){
  if(window.__rppayBuynowBound){return;} window.__rppayBuynowBound=true;
  var PENDING='rppay_pending';

  function resetButtons(){
    var bs=document.querySelectorAll('.rppay-buynow');
    for(var i=0;i<bs.length;i++){
      bs[i].setAttribute('aria-busy','false');
      var l=bs[i].querySelector('.rppay-buynow__label');
      if(l){l.textContent='Comprar ahora';}
    }
  }

  function syncCartBubble(count){
    try{
      var icon=document.querySelector('cart-icon');
      if(!icon){return;}
      var c=icon.querySelector('[ref="cartBubbleCount"]');
      var bubble=icon.querySelector('[ref="cartBubble"]');
      if(c){ c.textContent = count<100 ? String(count) : ''; c.classList.toggle('hidden', count===0); }
      if(bubble){ bubble.classList.toggle('visually-hidden', count===0); }
      icon.classList.toggle('header-actions__cart-icon--has-cart', count>0);
    }catch(e){}
  }

  function handleReturn(){
    var raw=null;
    try{ raw=sessionStorage.getItem(PENDING); }catch(e){}
    if(!raw){ return; }
    try{ sessionStorage.removeItem(PENDING); }catch(e){}
    var pend=null; try{ pend=JSON.parse(raw); }catch(e){}
    if(!pend||!pend.id){ return; }
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
     .then(function(r){return r.json();})
     .then(function(cart){
        var line=null;
        for(var i=0;i<cart.items.length;i++){ if(String(cart.items[i].id)===String(pend.id)){ line=cart.items[i]; break; } }
        if(!line){ return null; }
        var newQty=Math.max(0, line.quantity-(pend.qty||1));
        return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:pend.id,quantity:newQty})}).then(function(r){return r.json();});
     })
     .then(function(cart){ if(cart&&typeof cart.item_count==='number'){ syncCartBubble(cart.item_count); } })
     .catch(function(){});
  }

  document.addEventListener('click',function(e){
    var btn=e.target && e.target.closest ? e.target.closest('.rppay-buynow') : null;
    if(!btn){return;}
    e.preventDefault();
    if(btn.getAttribute('aria-busy')==='true'){return;}
    var scope=btn.closest('.product-details')||document;
    var idEl=scope.querySelector('[name="id"]');
    var vid=idEl?idEl.value:null;
    var qEl=scope.querySelector('[name="quantity"]');
    var qty=qEl?(parseInt(qEl.value,10)||1):1;
    var label=btn.querySelector('.rppay-buynow__label');
    if(!vid){window.location.href='/cart';return;}
    btn.setAttribute('aria-busy','true');
    if(label){label.textContent='Procesando...';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:qty}]})})
     .then(function(r){if(!r.ok){return r.json().then(function(j){throw j;});}return r.json();})
     .then(function(){
        try{ sessionStorage.setItem(PENDING, JSON.stringify({id:vid,qty:qty})); }catch(e){}
        window.location.href='/checkout';
     })
     .catch(function(err){
        btn.setAttribute('aria-busy','false');
        if(label){label.textContent='Comprar ahora';}
        try{ sessionStorage.removeItem(PENDING); }catch(e){}
        var m=(err&&err.description)?err.description:'No se pudo agregar el producto. Intenta de nuevo.';
        alert(m);
     });
  },false);

  // Al VOLVER (bfcache/restore): resetea el label + limpia el carrito pendiente.
  window.addEventListener('pageshow',function(){
    resetButtons();
    handleReturn();
  });
  // Al SALIR (justo antes de que el navegador congele/guarde la pagina): resetea.
  // Clave del fix: garantiza que el snapshot cacheado NUNCA quede en 'Procesando...'
  // aunque 'pageshow' no se dispare al volver (bug conocido de iOS Safari con bfcache).
  // pagehide se dispara cuando la navegacion ya esta comprometida, asi que resetear
  // aqui es seguro (no causa doble-envio) y NO desactiva el bfcache (a diferencia de unload).
  window.addEventListener('pagehide',function(){
    resetButtons();
  });
})();
